export const REPORT_PAYMENT_COLORS = {
  Efectivo: '#27AD60',
  'Transferencia Bancaria': '#E9C471',
  'Pago Digital': '#65BBE7',
  'Depósito Bancario': '#6175E5',
  Cheque: '#CE402C',
  'Tarjeta de Crédito': '#F4833B',
  'Vale Digital': '#C7C7C7'
}

export const REPORT_PAYMENT_TEXT_MAPPINGS = {
  'Transferencia Bancaria': 'Transferencia',
  'Depósito Bancario': 'Depósito',
  'Tarjeta de Crédito': 'Tarj. De Crédito',
  Efectivo: 'Efectivo',
  'Pago Digital': 'Pago Digital',
  Cheque: 'Cheque',
  'Vale Digital': 'Vale Digital'
}

export const REPORT_PAYMENT_NUMBER_FORMAT_RULES = [
  { limit: 1_000, format: (number) => number.toFixed(2) },
  { limit: 10_000, format: (number) => `${Math.floor(number / 100) / 10}k` },
  { limit: 1_000_000, format: (number) => `${Math.floor(number / 1000)}k` },
  { limit: 100_000_000, format: (number) => `${Math.floor(number / 1_000_000)}M` }
]
